export const useHttp = () => {
  const config = useRuntimeConfig()
  const locale = useCookieLocale()
  const csrf = useCookie('csrftoken')

  const defaultOpts = {
    credentials: 'include',
    mode: 'cors',
    method: 'POST',
    headers: {},
  }

  return async function http(url, opts = {}, busyState = null) {
    const endpoint = `${config.public.apiUrl}/${url.replace(/^\/+/g, '')}`

    const merged = { ...defaultOpts, ...opts, headers: {
        ...defaultOpts.headers,
        ...opts.headers,
      },
    }

    // Language header
    merged.headers['Accept-Language'] = locale.value

    // CSRF handling
    const method = merged.method.toUpperCase()

    if (['POST', 'PATCH', 'DELETE'].includes(method)) {
      if (csrf.value) {
        merged.headers['X-CSRFToken'] = csrf.value
      }

      if (!merged.files) {
        merged.headers['Content-Type'] = 'application/json'
      } else {
        delete merged.headers['Content-Type']
      }

      if (method === 'DELETE') {
        delete merged.headers['Content-Type']
      }
    }

    if (busyState) busyState.value = true

    try {
      const fetcher = import.meta.client ? $fetch : useRequestFetch();
      const data = await fetcher(endpoint, merged)

      const base = ['success', 'results', 'message']
      const meta = Object.keys(data)
        .filter(key => !base.includes(key))
        .reduce((obj, key) => {
          obj[key] = data[key]
          return obj
        }, {})

      return {
        data: data?.results,
        error: null,
        success: data.success,
        meta,
      }
    } catch (error) {
      const errorMessage = error?.data?.message || error?.message || 'Request failed'
      return {
        data: null,
        error: errorMessage,
        success: false,
        meta: {},
      }
    } finally {
      if (busyState) busyState.value = false
    }
  }
}
